<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill="#fff" d="M0 0h16v16H0z"/><path fill="none" stroke="currentColor" d="M.5.5h15v15H.5z"/><path fill="none" d="M0 0h16v16H0z"/><path fill="none" stroke="currentColor" d="M0 0h8" style="stroke-linecap:round;stroke-width:1.4px" transform="translate(4 8)"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-tree-open',
});
</script>
